<a class="navbar-brand">
  <img src="./assets/matas-logo.svg" alt="matas image" class="image" />
</a>
